module.exports = __webpack_public_path__ + "img/door-open.6760519b.svg";